import { NgModule } from '@angular/core'
import { OverlayModule } from '@angular/cdk/overlay'
import { AutocompleteSelectComponent } from './autocomplete-select/autocomplete-select.component'

import { TranslateModule } from '@ngx-translate/core'

import { WidgetsModule } from '@shared/widgets/widgets.module'
import { VendorModule } from '@shared/vendor.module'
import { DirectiveModule } from '@shared/directives/directive.module'

import { FormFieldComponent } from './form-field.component'
import { LabelComponent } from './label/label.component'
import { CheckboxSearchListComponent } from './checkbox-search-list/checkbox-search-list.component'
import { CheckboxListComponent, CheckboxOptionComponent } from './checkbox-list.component'
import { FileInputComponent } from './file-upload/file-input.component'
import { FilePickerComponent } from './file-upload/file-picker.component'
import { FileRowComponent } from './file-upload/file-row.component'
import { TimezoneSelectComponent } from './timezone-select/timezone-select.component'
import { AutocompleteFieldComponent } from './autocomplete-field/autocomplete-field.component'
import { DatepickerFieldComponent } from './datepicker-field/datepicker-field.component'
import { DatepickerFieldCustomComponent } from './datepicker-field/datepicker-field-custom.component'
import { MultiSelectFieldComponent } from './multi-select-field/multi-select-field.component'
import { MacAddressFormFieldComponent } from './mac-address-form-field'
import { ChatMessageInputComponent } from './chat-message-input/chat-message-input.component'
import { LanguageFieldComponent } from './language-field/language-field.component'
import { ImprovedSelectComponent } from './improved-select/improved-select.component'

@NgModule({
  declarations: [
    AutocompleteSelectComponent,
    CheckboxListComponent,
    CheckboxOptionComponent,
    CheckboxSearchListComponent,
    FormFieldComponent,
    LabelComponent,
    FileInputComponent,
    FilePickerComponent,
    FileRowComponent,
    TimezoneSelectComponent,
    AutocompleteFieldComponent,
    DatepickerFieldComponent,
    DatepickerFieldCustomComponent,
    MultiSelectFieldComponent,
    MacAddressFormFieldComponent,
    LanguageFieldComponent,
    ChatMessageInputComponent,
    ImprovedSelectComponent,
  ],
  imports: [DirectiveModule, TranslateModule.forChild(), VendorModule, WidgetsModule, OverlayModule],
  exports: [
    AutocompleteSelectComponent,
    CheckboxListComponent,
    CheckboxOptionComponent,
    CheckboxSearchListComponent,
    FormFieldComponent,
    LabelComponent,
    FileInputComponent,
    FilePickerComponent,
    FileRowComponent,
    TimezoneSelectComponent,
    AutocompleteFieldComponent,
    DatepickerFieldComponent,
    DatepickerFieldCustomComponent,
    MultiSelectFieldComponent,
    MacAddressFormFieldComponent,
    LanguageFieldComponent,
    ChatMessageInputComponent,
    ImprovedSelectComponent,
  ],
})
export class FormModule {}
